import React from 'react';
import { CheckBox as NativeCheckbox } from 'react-native';
import { CheckBox as KCheckbox } from '@ui-kitten/components';
export const Native = NativeCheckbox;
export const Kitten = (props) => {
    const { children, ...rest } = props;
    return (<KCheckbox {...rest}>
    {children}
  </KCheckbox>);
};
export default {
    Native,
    Kitten,
};
//# sourceMappingURL=Checkbox.js.map